module.exports = __webpack_public_path__ + "static/img/mastercard.e1efc600.png";